import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card'
import { Skeleton } from '@/components/ui/skeleton'
import { useFetchProfile } from '@/hooks/useFetchProfile'
import { toProfile } from '@/lib/link'
import { cn } from '@/lib/utils'
import { NostrUser } from '@nostr/gadgets/metadata'
import { SecondaryPageLink } from '@/PageManager'
import ProfileCard from './ProfileCard'

export default function Username({
  user,
  className,
  skeletonClassName,
  withoutSkeleton = false
}: {
  user: string | NostrUser
  className?: string
  skeletonClassName?: string
  withoutSkeleton?: boolean
}) {
  const { profile, isFetching } = useFetchProfile(user)
  if (isFetching && !withoutSkeleton) {
    return (
      <div className="py-1">
        <Skeleton className={cn('w-16', skeletonClassName)} />
      </div>
    )
  }
  if (!profile) return null

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <div className={className}>
          <SecondaryPageLink
            to={toProfile(typeof user === 'object' ? user.npub : user)}
            className="truncate hover:underline"
            onClick={(e) => e.stopPropagation()}
          >
            {profile.shortName}
          </SecondaryPageLink>
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-80">
        <ProfileCard user={user} />
      </HoverCardContent>
    </HoverCard>
  )
}
